export default "__VITE_ASSET__CsGIs0J6__"